jQuery(function($){
  $('.movies-listing .sv-g').masonry({
    columnWidth: $('.movies-listing__list .sv-u-1').eq(0).outerWidth()
  });
});
